import { BehaviorSubject } from "rxjs";
import { scan, distinctUntilChanged, shareReplay } from "rxjs/operators";
import { isEqual } from "lodash";

// This will eventually become a problem since we'll want to clear the state when we get a new analytics url.
const QueryStore = () => {
  const $ = new BehaviorSubject().pipe(
    scan((state, action = {}) => {
      switch (action.__id) {
        case "ADD_QUERY":
          return [...state, action.query];
        case "REMOVE_QUERY":
          return state.filter((query) => !isEqual(query.parent, action.parent));
        default:
          return state;
      }
    }, []),
    distinctUntilChanged(),
    shareReplay(1)
  );
  return {
    $,
    destroy: () => {
      $.complete();
    },
    actions: {
      addQuery: ({ parent, hits, label, icon, color, type }) =>
        $.next({
          __id: "ADD_QUERY",
          query: {
            parent,
            hits,
            label,
            icon,
            type,
          },
        }),
      removeQuery: (parent) =>
        $.next({
          __id: "REMOVE_QUERY",
          parent,
        }),
    },
  };
};

export default QueryStore;
